import gql from 'graphql-tag';

export const CHANGE_EMAIL_START = gql`
  mutation changeEmailStart($emailChangeStart: ChangeEmailStartInput!) {
    changeEmailStart(input: $emailChangeStart) {
      ... on ChangeEmailStartSuccess {
        ref
      }
      ... on ChangeEmailStartFailure {
        error {
          __typename
          message
          code
          reason
          ... on AccountValidationError {
            details {
              message
              code
              path {
                field
                path
              }
              reason
            }
          }
        }
      }
    }
  }
`;
